const project = {
	name: 'fe-simuladorpublicopyme',
	version: '3.11.0',
};

export const environment = {
	production: true,
	header: {
		'X-IBM-Client-Id': 'd47111e8-dc9a-4dbc-83af-9f8274c9f90a',
		'Application-Id': `${project.name}-${project.version}`,
		'Reference-Service': project.name,
		'Content-Type': 'application/json',
		'Origin-addr': '11111',
		Channel: '132',
	},
};
export const SITE_RECAPTCHA_KEY = '6Ld86MUUAAAAABys_wPL-N-vjt-ADus5D4CD4dYO';

const hostWeb = 'https://swc.bci.cl/pyme';
export const fe_products = {
	simuladorFogape: `${hostWeb}/fe-simuladorpublicofogape-pyme-re-v1-5`,
	simuladorCompraCartera: `${hostWeb}/fe-simuladorpublicocompracartera-pyme-re-v1-3`,
};

const apiUrl = 'https://apilocal.bci.cl';
export const apis = {
	simuladorPublicoPymeExp: `${apiUrl}/bci-produccion/api-bci/operaciones-y-ejecucion/creditos-y-depositos/ms-simuladorpublicopyme-exp/v2.2`,
	bffNormativoConsentimientos: `${apiUrl}/bff-normativo-consentimientos/v1.0`,
};
